import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { queryThen } from "@/utils/query/mergeQueries.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { VmParameter } from "@warrenio/api-spec/spec.oats.gen";
import { mapFrom } from "@warrenio/utils/collections/maps";
import { atom } from "jotai/vanilla";

type Response = VmParameter[];

export const queryKey: QueryKey = ["vm_parameters"];

function getQuery(client: ApiClient) {
    return queryOptions({
        queryKey,
        queryFn: async ({ signal }): Promise<Response> => {
            return getResponseData(await client.GET("/api/parameters/vm", { signal }));
        },
    });
}

const parametersQueryAtom = atomFromStandardQueryOptions(getQuery);

/** Map from parameter name to the param */
export const parametersByNameAtom = atom((get) =>
    queryThen(get(parametersQueryAtom), (data) => mapFrom(data, (param) => param.parameter)),
);
